<template lang="pug">
.code-content
  JsonDisplay
</template>

<script>
import JsonDisplay from "@/components/JsonDisplay.vue";

export default {
  name: "Home",
  components: { JsonDisplay },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.home {
  flex: 1 0;
  display: flex;
  flex-flow: column nowrap;
  overflow: auto;
  padding: 0;
  text-align: left;
  align-items: stretch;
}

</style>
